import { ready } from '~/core'

ready('body_vh', 'body', (body) => {
  window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  })
})

let hash = false
const getHash = () => {
  if (location.hash) {
    const { origin, pathname, search } = window.location
    hash = location.hash
    location.hash = ''
    history.replaceState({}, '', `${origin}${pathname}${search}`)
    setTimeout(() => {
      history.replaceState({}, '', `${origin}${pathname}${search}${hash}`)
    }, 100)
  }
}
getHash()

ready('body_scroll_to', 'body', async (body) => {
  if (hash) {
    const destination = document.querySelector(hash);
    const page = document.querySelector('.pageWrap');
    const iframes = [...document.querySelectorAll('iframe')];
    const header = document.querySelector('header');

    if (!destination) {
      console.warn("[Scroll Debug] No destination element found for hash:", hash);
      return;
    }

    let allIframesLoaded = iframes.length === 0; // Tracks only iframes
    let pageLoaded = false; // Tracks full page load
    let hasScrolled = false; // Ensures we scroll only once
    let timeout = false;


    const getHeaderHeight = () => {
      return header ? header.offsetHeight : 0;
    };

    const attemptScroll = (triggerSource) => {

      if (!hasScrolled && pageLoaded && allIframesLoaded) {
        const headerHeight = getHeaderHeight();
        
        window.scrollTo({
          top: destination.getBoundingClientRect().top - headerHeight, // Account for sticky header
          behavior: 'smooth',
        });

        hasScrolled = true;
        clearTimeout(timeout); // Cancel timeout
        observer.disconnect(); // Stop layout watching
      } else {
      }
    };

    // Detect when all iframes have loaded
    if (!allIframesLoaded) {
      let loadedCount = 0;
      iframes.forEach((iframe, index) => {
        if (!iframe.checkVisibility()) {
          loadedCount++;
        }

        iframe.addEventListener("load", () => {
          loadedCount++;
          if (loadedCount === iframes.length) {
            allIframesLoaded = true;
            attemptScroll("All iframes loaded");
          }
        });

        if (loadedCount === iframes.length) {
          allIframesLoaded = true;
          attemptScroll("All iframes hidden");
        }
      });
    }

    // Detect when the entire page (CSS, images, etc.) has loaded
    window.addEventListener("load", () => {
      pageLoaded = true;
      attemptScroll("Window load event");
    });

    // Temporary observer for late layout shifts (disconnects after first scroll)
    const observer = new MutationObserver(() => {
      attemptScroll("MutationObserver triggered");
    });
    observer.observe(page, { childList: true, subtree: true });

    // Failsafe: Scroll after a delay in case something blocks `load`
    timeout = setTimeout(() => {
      attemptScroll("Timeout fallback");
    }, 1000);
  }
});



ready('icon-fonts', 'body', () => {
  const waitForIconFonts = async () => {
    let fontsLoaded = false
    while (!fontsLoaded) {
      if (document.fonts.check('16px Material Icons')) {
        fontsLoaded = true
        document.documentElement.classList.add('icons-ready')
      } else {
        await new Promise((resolve) => setTimeout(resolve, 200))
      }
    }
  }
  waitForIconFonts()
})

window.signalAsync = () => false
